import React from 'react';
import { motion } from 'framer-motion';
import { Moon } from 'lucide-react';
export function OpeningHook() {
  return <section className="bg-light text-text-light py-20 md:py-28 px-6 relative" data-id="element-121">
      <div className="max-w-3xl mx-auto text-center" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center space-y-8" data-id="element-123">
          <Moon className="w-10 h-10 text-accent" strokeWidth={1.5} data-id="element-124" />

          <div className="space-y-8 text-xl md:text-2xl leading-relaxed font-serif text-text-light/90" data-id="element-125">
            <p className="italic" data-id="element-126">
              "Son las 3:14 AM. Estás sentada en la oscuridad, con la espalda
              dolorida y los ojos ardiendo, meciendo a un bebé que parece
              despertarse en el segundo exacto en que intentas dejarlo en la
              cuna."
            </p>

            <p className="italic" data-id="element-127">
              "Sientes un nudo en la garganta. No es solo cansancio; es un
              agotamiento profundo que te hace sentir que estás fallando, que tu
              paciencia se agota y que no puedes disfrutar la maternidad como
              soñaste."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}